export default {
  consentBanner: {
    title: 'เว็บไซต์นี้ใช้คุกกี้',
    description:
      'เราใช้คุกกี้เพื่อให้ท่านได้รับประสบการณ์การใช้งานที่ดีที่สุดบน\xa0\nเว็บไซต์ของเรา โปรดศึกษาเพิ่มเติมที่',
    policyBtn: 'นโยบายความเป็นส่วนตัว',
    separator: 'และ',
    cookiePolicyBtn: 'นโยบายคุกกี้',
    acceptBtn: 'ตกลง',
  },
  cookieSetting: {
    title: 'การปรับแต่งคุกกี้',
    subTitle: 'ท่านสามารถปรับแต่งการใช้งานคุกกี้ได้ตามรายละเอียดต่อไปนี้',
    cookies: {
      necessary: {
        title: 'คุกกี้ที่จำเป็นสำหรับการทำงานของเว็บไซต์',
        subTitle: 'Strictly Necessary Cookies',
        description:
          'คุกกี้ประเภทนี้มีความสำคัญต่อการปฏิบัติการของเว็บไซต์ www.sanook.com ซึ่งจะช่วยให้ท่านสามารถเข้าถึงข้อมูลและเนื้อหาต่างๆ ของเว็บไซต์เราได้ทุกส่วน โดยเฉพาะส่วนสมาชิกผู้ใช้งานของเว็บไซต์ ตลอดจนการตรวจสอบจำนวนผู้เข้าเยี่ยมชมเว็บไซต์ของเรา',
      },
      performance: {
        title: 'คุกกี้ด้านประสิทธิภาพการทำงานของเว็บไซต์',
        subTitle: 'Performance Cookies',
        description:
          'คุกกี้ประเภทนี้ใช้เพื่อรวบรวมข้อมูลทางสถิติเกี่ยวกับการใช้งานเว็บไซต์ของท่าน เพื่อวิเคราะห์ และช่วยให้เราทราบถึงพฤติกรรมการใช้งาน ซึ่งจะช่วยปรับปรุงการทำงานของเว็บไซต์เพื่อให้ท่านได้รับประสบการณ์ที่ดีที่สุดในการใช้งานบนเว็บไซต์ของเรา',
      },
      targeting: {
        title: 'คุกกี้เพื่อปรับเนื้อหาเข้ากับกลุ่มเป้าหมาย',
        subTitle: 'Targeting Cookies',
        description:
          'คุกกี้ประเภทนี้ใช้ในการบันทึก และจดจำคุณลักษณะต่างๆ ที่ท่านได้เลือกขณะเข้าชมเว็บไซต์ของเรา เช่น หมวดหมู่ และเนื้อหาที่ท่านชอบอ่านมากที่สุด เราจะบันทึกข้อมูลเหล่านี้ และนำกลับมาใช้เมื่อท่านกลับเข้ามาที่เว็บไซต์ของเราอีกครั้ง เพื่อปรับให้ท่านได้รับชมเนื้อหาได้ตรงกับความชอบของท่านให้มากที่สุด',
      },
      advertising: {
        title: 'คุกกี้เพื่อนำเสนอโฆษณาให้เข้ากับกลุ่มเป้าหมาย',
        subTitle: 'Advertising Cookies',
        description:
          'คุกกี้ประเภทนี้ใช้เพื่อจดจำพฤติกรรมการอ่านเนื้อหาบนเว็บไซต์ของท่าน รวมถึงรายละเอียดของอุปกรณ์ที่ท่านใช้ เพื่อนำไปใช้วิเคราะห์การนำเสนอโฆษณาที่เหมาะสมกับท่านมากที่สุด และช่วยวัดความมีประสิทธิผลของโฆษณาที่เรานำเสนอด้วย ตลอดจนช่วยป้องกัน หรือจำกัดจำนวนครั้งที่ท่านจะเห็นโฆษณาเดิมซ้ำๆ',
      },
    },
    description:
      'ข้อมูลที่ได้และใช้ประมวลผลจากการใช้คุกกี้นั้นเป็นการเก็บข้อมูลทางสถิติจากการจราจรทางคอมพิวเตอร์เท่านั้น ไม่สามารถบ่งบอก หรือระบุความเป็นตัวตนของท่านได้ ท่านสามารถปรับแต่งข้อมูลวิธีการที่เราใช้คุกกี้ได้จากด้านบนและทำการบันทึกข้อมูล',
    acceptAllBtn: 'ยอมรับทั้งหมด',
    saveBtn: 'บันทึกข้อมูล',
  },
}
